import { Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";

const CommonSlider = ({ open, onClose, children = "",top = true }) => {
  const formRef = useRef(null);

  const handleBackdropClick = (e) => {
    if (open && e.target === e.currentTarget) {
      onClose(false);
    }
  };

  const handleMouseDown = (e) => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const newWidth = formRef.current.clientWidth - e.movementX;
    if (newWidth >= 800 && newWidth <= window.innerWidth * 0.8) {
      formRef.current.style.width = `${newWidth}px`;
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    }
    else {
      document.body.style.overflow = "auto";
    }
  }, [open])
  
  return (
    <>
      <Transition
        show={open}
        as={Fragment}
        enter="ease-in-out duration-500"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in-out duration-500"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div 
          className={`fixed inset-0 transition-opacity ${top ? 'z-10':'z-30'}`}
          onClick={handleBackdropClick}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </Transition>

      <Transition
        show={open}
        as={Fragment}
        enter="transform transition ease-in-out duration-500 sm:duration-700"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transform transition ease-in-out duration-500 sm:duration-700"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
      >
        <div className={`fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16 ${top ? 'z-30 top-[73px]':'z-30'}`}>
          <div
            ref={formRef}
            className="w-[800px]"
          >
            <div className="flex w-full h-full ml-auto bg-white shadow-xl form-container">
              <div
                onMouseDown={handleMouseDown}
                className="w-[20px] h-full cursor-col-resize flex items-center justify-center bg-gray-50 hover:bg-gray-100 "
              >
                <ReactSVG src="/icons/vertical-dots.svg" />
              </div>
              {children}
            </div>
          </div>
        </div>
      </Transition>
    </>
  );
};

export default CommonSlider;
